<template>
    <div class="wrapper" @click="capture">
        <div class="top-content">
            <div class="top-content-element2" @click="showMenu">
            <!-- <div class="top-content-element"> -->
                <div class="inner-title">Loan Amount(₹)</div>
                <div class="top-content-inner">
                    <span class='tci-amount' v-text="obj.selectAmount"></span>
                    <i class="icon icon-white-arrow-up"></i>  
                </div>
                <ul class="amount-list" v-show='list_show'>
                    <li class="amount-element" @click.prevent="selected($event, ind)" :class="{'active': ind === selected_ind}" v-for="(ele, ind) in obj.amountList" :key="ind" v-text="ele"></li>
                </ul>
            </div>            
            <div class="top-content-element">
                <div class="inner-title">Repayment Amount</div>
                <div class="top-content-inner small-font" v-text="obj.repaymentAmount"></div>
            </div>
            <div class="top-content-element">
                <div class="inner-title">Interests rate</div>
                <div class="top-content-inner small-font" v-text="obj.interestRate + '%/day'"></div>
            </div>
        </div>  
        <div class="detail-info">
            <ul class="detail-list">                
                <li class="detail-list-element"><span class="left-text">Interest Fee</span><span class="right-text" v-text="`₹${obj.interestFee}`"></span></li>                
            </ul>
        </div>    
        <ul class="other-info">
            <li class="oi-element">
                <router-link :to="`/bank?pid=${$route.params.pid}`" class="alink">
                    <div class="left-content">
                        <h4 class="oi-title">Bank Account</h4>
                        <div class="oi-content" :class="{'no-choice': !bank_info.have_bank}" v-text="bank_info.have_bank? bank_info.card_no : 'Click To Select Bankcard'"></div>                        
                    </div>
                    <div class="right-content">
                        <i class="icon icon-arrow-right"></i>
                    </div>
                </router-link>
            </li>
            <!-- <li class="oi-element"  @click="showUseage">
                <div class="left-content">
                    <h4 class="oi-title">Usage of Loan</h4>
                    <div class="oi-content no-choice" v-show='useage_info.selected_ind == null'>Please Select Usage of Loan</div>
                    <div class="oi-content" v-show='useage_info.selected_ind != null' v-text='useage_info.choices[useage_info.selected_ind]'></div>
                </div>
                <div class="right-content">
                    <i class="icon icon-arrow-right"></i>
                </div>
                <ul class="choice-container" v-show="useage_info.is_show">
                    <li class="choice-element" :class="{'active': useage_info.selected_ind === ind}" v-for="(item, ind) in useage_info.choices" :key="ind" @click="useage_selected($event,ind)" v-text="item"></li>
                </ul>
            </li> -->
        </ul>
        <div class="auto">
            <div class="auto-content">
                <h3 class='auto-title'>Automatically get money?</h3>
                <p class="auto-text">
                  Please note that the amount approved may be differentfrom the amount applied for.  
                </p>                
            </div>
            <div :class="['e__switch',{'e_is-checked': auto_get}]">
                    <span class="e__switch-core" @click="toggle"></span>
                </div>
        </div>
        <div class="adv-place">
            <a href="javascript:void(0);" @click="showBigDialog">
                <img src="../../assets/images/callback/product-adv.png" alt="">
            </a>            
        </div>
        <div class="btn-container">
            <a class="btn-submit" @click.prevent="submit">APPLY NOW</a>
        </div>
        <div class="btn-container-placeholder"></div>
        <div class="big-dialog-wrapper" v-show="bigDialogState">
            <div class="big-dialog-inner">
                <a href="javascript:void(0);" class="icon icon-close" @click="closeBigDialog"></a>
                <div class="big-dialog">                
                    <div class="big-content">
                    <div class="big-element cooper">
                        <h2 class="be-title"><div class='be-title-left'><i class="icon icon-copper-lock"></i><span class="title-text">Copper Lock</span></div><a href="javascript:void(0);" class="btn-close" @click="closeBigDialog">APPLY NOW</a></h2>
                        <div class="be-content">
                            <div class="bec-element"><span class="left">Unlocking condition:</span><span class="right">Successfully repay a loan on time</span></div>
                            <div class="bec-element"><span class="left">Discount scheme:</span><span class="right">Maximum service fee reduction of 5%</span></div>
                        </div>
                    </div>
                    <div class="big-element sliver">
                        <h2 class="be-title"><div class='be-title-left'><i class="icon icon-siliver-lock"></i><span class="title-text">Silver Lock</span></div><a href="javascript:void(0);" class="btn-close" @click="closeBigDialog">APPLY NOW</a></h2>
                        <div class="be-content">
                            <div class="bec-element"><span class="left">Unlocking condition:</span><span class="right">Successfully repay two loan on time</span></div>
                            <div class="bec-element"><span class="left">Discount scheme:</span><span class="right">Maximum service fee reduction of 9%</span></div>
                        </div>
                    </div>
                    <div class="big-element gold">
                        <h2 class="be-title"><div class='be-title-left'><i class="icon icon-gold-lock"></i><span class="title-text">Gold Lock</span></div><a href="javascript:void(0);" class="btn-close" @click="closeBigDialog">APPLY NOW</a></h2>
                        <div class="be-content">
                            <div class="bec-element"><span class="left">Unlocking condition:</span><span class="right">Successfully repay four loan on time</span></div>
                            <div class="bec-element"><span class="left">Discount scheme:</span><span class="right">Maximum service fee reduction of 13%</span></div>
                        </div>
                    </div>                    
                    </div>
                </div>
            </div>    
        </div>
    </div>
</template>
<style lang="less" scoped>
@import "~assets/less/icon.less";
    .big-dialog-wrapper{
        position:fixed;
        top:0;
        bottom:0;
        left:0;
        right:0;
        width: 100%;
        height:100%;
        background:RGBA(255, 50, 163, 1);
        background-size: 100% 100%;
        overflow: auto;
        z-index: 999;  
        div.big-dialog-inner{
            width: 100%;
            min-height: 1509px;
            background:url("../../assets/images/callback/dbg.png") no-repeat;
            background-size: contain;
            position: absolute;
            top:0;
            left:0;
            padding-bottom: 50px;            
        }      
        .icon-close{
            position: absolute;
            top:40px;
            right:40px;
        }
        .big-dialog{
            background:#fff;
            width: 616px;
            // height: 876px;
            padding:25px 35px;
            margin:220px auto 0 auto;
            border-radius: 20px;
            .bec-element{                
                line-height: 1.5;
                .left{                    
                    color:#333;
                    font-size: 28px;
                    font-weight: 700;
                }
                .right{
                    color:#333;
                    font-size: 28px;
                }
            }
            .big-element{
                margin-bottom: 50px;
                &.cooper{
                    .be-content{
                        background:rgba(250, 177, 140, 0.15);
                        padding:20px;
                        width: 566px;
                        margin-top: 30px;
                        border-radius: 20px;
                        .bec-element{
                            &::nth-child(2){
                                .right{
                                    color:rgba(233, 144, 107, 1)
                                }
                            }
                        }
                    }
                    
                }
                &.siliver{
                    .be-content{
                        background:RGBA(248, 249, 255, 1);
                        padding:20px;
                        width: 566px;
                        .bec-element{
                            &::nth-child(2){
                                .right{
                                    color:RGBA(125, 133, 198, 1)
                                }
                            }
                        }
                    }
                    
                }
                &.gold{
                    .be-content{
                        background:RGBA(255, 248, 238, 1);
                        padding:20px;
                        width: 566px;
                        .bec-element{
                            &::nth-child(2){
                                .right{
                                    color:RGBA(241, 138, 25, 1)
                                }
                            }
                        }
                    }
                    
                }
                .be-title{
                    display: flex;
                    justify-content: space-around;
                    color:#333;
                    margin-bottom: 30px;
                    .be-title-left{
                        display:flex;
                        justify-content: start;
                    }
                    .title-text{
                        display: block;
                        font-size: 34px;
                        display: flex;
                        justify-content: start;
                        align-items: center;
                        margin-left: 15px;
                        font-weight: 700;
                    }
                    .btn-close{
                        display: block;
                        width:190px;
                        height:60px;
                        border-radius: 10px;
                        font-size: 24px;
                        background:#8261FF;
                        color:#fff;
                        text-align: center;
                        line-height: 60px;
                        margin-left: 100px;
                        &:active{
                            transform: scale(1.1,1.1);
                        }
                    }
                    .icon{
                        margin:0
                    }
                    .icon-gold-lock{
                        width: 40px;
                        height: 50px;
                        background:url("../../assets/images/callback/icon-gold.png") no-repeat;
                        background-size:100% 100%;
                    }
                    .icon-copper-lock{
                        width: 40px;
                        height: 50px;
                        background:url("../../assets/images/callback/icon-copper.png") no-repeat;
                        background-size:100% 100%;
                    }
                    .icon-siliver-lock{
                        width: 40px;
                        height: 50px;
                        background:url("../../assets/images/callback/icon-siliver.png") no-repeat;
                        background-size:100% 100%;
                    }
                }
            }
        }
    }
.adv-place{
    margin-top: 30px;
    width:670px;
    height: 100px;
    border-radius: 20px;
    overflow: hidden;
    img{
        width: 100%;
        height: 100%;
    }
}
.auto{
    width: 590px;
    padding:40px;
    height: 136px;
    background: linear-gradient(180deg, #fff 0%, #EFEEF8 100%);
    border-radius: 20px;
    margin:30px auto;
    position:relative;
    .auto-content{        
        .auto-title{
            color:#8a7ef7;
            font-weight: 700;
            margin-bottom: 30px;
            font-size: 28px;
        }
        .auto-text{
            font-size: 24px;
            color:#8a7ef7;
            line-height: 1.5;
            font-weight: 300;
        }
    }
}
.btn-container-placeholder{
    height: 100px;
}
.choice-container{  
        // display: none;      
        position: absolute;
        width: 575px;
        padding:0 30px;      
        background:#fff; 
        z-index:99; 
        box-shadow: 0px 0px 44px 0px rgba(9, 14, 118, 0.08);
        top:250px;        
        .choice-element{            
            border-bottom: 2px solid #EFEEF1;
            padding:40px;            
            color:#000;
            font-size: 32px;
            &.active{
                color:#8960e8;
            }
        }
    }
.other-info{
    
    .oi-element{
        padding:40px;
        border-bottom: 2px solid #EFEEF1;
        overflow: hidden; 
        .alink{
            display:block;
            width: 100%;
            height: 100%;
        }       
        .left-content{
            float:left;
            .oi-title{
                color:#A59BB3;
                font-size: 26px;
            }
            .oi-content{
                font-size: 30px;
                color:#000;
                margin-top: 30px;
                &.no-choice{
                    color:#D0CDDA;
                }
            }
        }
        .right-content{
            float:right;
            position: relative;
            margin-top: 40px;
        }
    }
}
.wrapper{
    padding: 50px;    
    .top-content{
        position:relative;
        width: 564px;
        height: 240px;
        background:url("~assets/images/product_bg.png") no-repeat;
        background-size: 100% 100%;
        padding:40px; 
        // overflow:hidden;
        .top-content-element2{
            width: 100%;
            margin-bottom: 30px;
            .inner-title{
                color:#D9CCFF;
                font-size: 24px;
                margin-bottom: 15px;
                width: 100%;
                text-align: center;
            }
            .top-content-inner{
                color:#fff;
                font-size: 64px;
                font-weight: 700;
                position:relative;
                align-items: center;
                justify-content: center;
                width: 100%;
                text-align:center;
                .tci-amount{
                    
                }
                .icon{
                    position:absolute;
                    top:20px;
                    right:100px;
                }
                // text-align: center;
            }
        }
        .top-content-element{
            width:50%;
            float:left;
            margin-bottom: 60px;
            .inner-title{
                color:#D9CCFF;
                font-size: 24px;
                margin-bottom: 15px;
            }
            .top-content-inner{
                color:#fff;
                font-size: 64px;
                font-weight: 700;
                display: flex;
                align-items: center;
            }
            .small-font{
                font-size: 48px;
            }
            
        }       

    }
    .detail-info{
        background:#F5F4FA;
        padding:40px 40px 10px 40px;
        width: 564px;
        margin-top: -20px;
        .detail-list{
            clear: both;
            .detail-list-element{
                // overflow:hidden;
                margin-bottom: 30px;
                height:30px;
                .left-text{
                   float:left;
                   color:#A59BB3;
                   font-size: 28px; 
                }
                .right-text{
                    float:right;
                    color:#A59BB3;
                    font-size: 28px;
                }
            }
        }
    }
    .btn-container{
        position:fixed;
        bottom:50px;
        left:10px;
        width: 100%;
        height: 96px;
        .btn-submit{
            display: block;
            width: 670px;
            height: 96px;
            line-height: 96px;
            text-align: center;
            border-radius: 12px;
            background:#8960e8;
            font-size: 32px;
            margin:0 auto;
            color:#fff;
        }
    }
    .amount-list{
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        background:rgba(255,255,255,1);
        border-radius: 15px;;
        z-index: 99999;
        padding:0 30px;
        .amount-element{
            text-align:center;
            width: 150px;
            padding:30px;
            color:#A59BB3;
            font-size: 28px;   
            border-bottom: 2px solid #e0e0e0;   
            &:last-child{
                border-bottom: none;
            }      
            &:hover{
                color:#8960e8;
                border-bottom-color:#e0e0e0;   
            }
        }
        
    }
}
.e__switch {
    position:absolute;
    top:40px;
    right:40px;
        display: inline-flex;
        align-items: center;
        font-size: 14px;
        line-height: 20px;
        height: 20px;
        vertical-align: middle;
        cursor: pointer;
    }

    .e__switch>input {
        position: absolute;
        width: 0;
        height: 0;
        opacity: 0;
        margin: 0;
    }

    .e__switch-core {
        margin: 0;
        position: relative;
        width: 100px;
        height: 50px;
        border: 1px solid #DCDFE6;
        outline: 0;
        border-radius: 50px;
        box-sizing: border-box;
        background: #d4d1f3;
        transition: border-color .3s, background-color .3s;
        vertical-align: middle;
    }

    .e__switch-core::after {
        content: "";
        position: absolute;
        top: 0px;
        left: 0px;
        border-radius: 100%;
        transition: all .3s;
        width: 50px;
        height: 50px;
        background-color: #EFEEF8;
    }
    
    .e__switch.e_is-checked .e__switch-core {
        border-color: #8a7ef7;
        background-color: #8a7ef7;
    }
    
    .e__switch.e_is-checked .e__switch-core::after {
        left: 100%;
        margin-left: -49px;
    }
</style>
<script>
import { productInfo, calculate, getBank, apply, prechech, uploadDeviceInfo,isNeedUplod,bury} from '@api/index'
import { onMounted,reactive,ref, getCurrentInstance, onBeforeMount, onBeforeUnmount } from 'vue'
import {useRouter} from 'vue-router'
import { useLoading } from 'vue-loading-overlay'
import { useStore } from 'vuex'
// import { getAnalytics, logEvent } from 'firebase/analytics'
export default {
    setup () {                
        const router = useRouter()
        const route = router.currentRoute        
        const $loader = useLoading()
        const clicked = ref(false)
        const store = useStore()
        const list_show = ref(false)
        const selected_ind = ref(0)
        const proxy  = getCurrentInstance().proxy
        const auto_get = ref(1)
        // const analytics = getAnalytics()
        // const addressGetState = ref(0)
        let bigDialogState = ref(false)
        const closeBigDialog = () => {
            bigDialogState.value = false
        }
        const showBigDialog = () => {
            bigDialogState.value = true
        }
        const toggle = () => {
            if(auto_get.value == 0) {
                auto_get.value = 1
            } else {
                auto_get.value = 0
            }
        }
        let useage_info = reactive({
            choices:['Shopping','Medical treatment','Education','Tourism','Living expenses','Purchase of vehicles'],
            selected_ind: null,
            value:"",
            is_show:false
        })
        let obj = reactive({
            amountList:[],
            selectAmount:'',
            serviceRate:'',
            interestRate: '',
            processFee:'',
            gstFee:'',
            interestFee:'',
            period: ''
        })
        let bank_info = reactive({
            card_no:'',
            bank_id:route.value.query.bank_id || '',
            have_bank:''
        })
        onBeforeMount(()=>{
            store.dispatch('bury', {eventId:"apply_page_view"})
            store.dispatch("clearBuryCache", [])
        })
        onBeforeUnmount(()=>{
            store.dispatch('bury', {eventId:"apply_page_exit_page_tech"})
            store.dispatch("clearBuryCache", [])
        })              
        onMounted(async ()=>{
            const loader = $loader.show({
                container:null
            })
            bury({
                    "projectName":"creditChar", 
                    "pageName":"prodcutDetail",
                    "behavior":"enter",
                    "value":"enter",
                    "eventTime":""
            })
            const dd = await prechech({
                productId: route.value.params.pid
            })
            
            if(dd.code == 0) {
                if(dd.data.orderStatus == 0) {
                    loader.hide()
                    router.replace({
                        "path":`/product/${route.value.params.pid}/denied`,
                        "query":{
                            "day":dd.data.rejectStatusVO.day,
                            "hour":dd.data.rejectStatusVO.hour
                        }
                    })
                    return
                } 
                if(dd.data.orderStatus == 2) {
                    loader.hide()
                    router.replace({
                        "path":`/order`,                        
                    })
                    return
                }                
            }

            productInfo({
                id: route.value.params.pid
            }).then(data => {
                obj.amountList = data.data.amountList
                obj.period = data.data.period
                obj.selectAmount = data.data.amountList[data.data.amountList.length - 1]
                selected_ind.value = data.data.amountList.length - 1
                obj.interestRate = data.data.interestRate

                calculate({
                    productId: route.value.params.pid, 
                    amount: data.data.amountList[data.data.amountList.length - 1],
                    period: 7
                }).then(data2=>{
                    obj.repaymentAmount = data2.data.repaymentAmount
                    obj.processFee = data2.data.serviceFee
                    obj.gstFee = data2.data.gstFee
                    obj.interestFee = data2.data.interest
                })
            })
            getBank({
                productId:route.value.params.pid
            }).then(data3 => {
                if(data3.code == 0) {
                    if(data3.data.length > 0) {
                        if(bank_info.bank_id.length) {
                            const target = data3.data.filter((ele)=>{
                                return ele.id == bank_info.bank_id
                            })
                            bank_info.card_no = target[0].cardNo
                            bank_info.bank_id = target[0].id
                            
                        } else {
                            bank_info.card_no = data3.data[0].cardNo
                            bank_info.bank_id = data3.data[0].id                        
                        }
                        bank_info.have_bank = true
                    } else {
                        bank_info.have_bank = false
                    }
                }
            })

            loader.hide()

            const needUplodDevice = await isNeedUplod()
            let gpsState = false        
            if(needUplodDevice.code == 0) {             
                for(let i = 0; i < needUplodDevice.data.length;i++) {
                    const element = needUplodDevice.data[i]
                    if(element.type == 'gps') {
                        gpsState = element.needUpload
                    }
                }
            }
            if(gpsState) {
                try{
                    const position = await requestPosition()
                    await uploadDeviceInfo({
                        "gps":{
                            address:"",
                            latitude:position.coords.latitude,
                            longitude:position.coords.longitude
                        }                    
                    })
                } catch(e) {
                    // proxy.$toast.show("Please allow to access your location")
                }                
            }             
        })
        const showMenu = (e) => {
            e.stopPropagation();
            list_show.value = true
        }
        const validate = () => {
            let res = true
            if(bank_info.bank_id == '') {
                proxy.$toast.show(`
                    Attention!<br>
                    Just one step away from receiving cash!<br>
                    Add payment account
                `)
                res = false
            } 
            // else if (useage_info.value.length  == 0) {                
            //     proxy.$toast.show('Please Select Usage of Loan')
            //     res = false
            // }
            return res
        }
        const requestPosition = function () {
            return new Promise((resovle, reject)=>{
                navigator.geolocation.getCurrentPosition(async (position)=>{                
                    resovle(position)
                }, (error)=>{
                    reject(error)
                });
            })
        }
        const submit = async () => {
            store.dispatch('bury', {eventId:"apply_page_enter_button_click"})
            if(clicked.value)return            
            if(!validate())return            
            clicked.value = true
            

            const loader = $loader.show({
                container: null
            })          
            loader.hide()
            clicked.value = false                               
            apply({
                // loanUse:useage_info.value,
                cardId:bank_info.bank_id,
                borrowAmount:obj.selectAmount,
                periods: obj.period,
                productId: route.value.params.pid,
                checkEmail:0,
                autoGetMoney:1,
                autoMoney:auto_get.value
            }).then((res)=>{
                loader.hide()
                if(res.code == 0) {
                    // logEvent(analytics, 'apply')
                    store.dispatch('bury', {eventId:"apply_page_enter_button_click_success"})
                    store.dispatch('uploadBury')
                    window.fbq('track', 'SubmitApplication');  
                    setTimeout(()=>{
                        router.replace({
                            path:"/order"
                        })
                    },300)        
                    
                } else {                    
                    proxy.$toast.show(res.msg)
                    store.dispatch('bury', {eventId:"apply_page_enter_button_click_success",message: res.msg})
                }    
                clicked.value = false       
            })   
            // }
                     
        }
        const capture = () => {
            list_show.value = false
        }
        const selected = async (e, ind) => {
            e.stopPropagation()
            obj.selectAmount = obj.amountList[ind]
            selected_ind.value = ind
            list_show.value = false
            const data2 = await calculate({
               productId: route.value.params.pid, 
               amount: obj.selectAmount,
               period: 7
            })            
            obj.repaymentAmount = data2.data.repaymentAmount
            obj.processFee = data2.data.serviceFee
            obj.gstFee = data2.data.gstFee
            obj.interestFee = data2.data.interest
        }
        const showUseage = () => {
            useage_info.is_show = true
        }
        const useage_selected = (e,ind) => {
            e.stopPropagation()            
            useage_info.selected_ind = ind 
            useage_info.is_show = false
            useage_info.value = ind
        }        
        return {
            obj, 
            selected_ind,           
            list_show,
            bank_info,
            useage_info,
            auto_get,
            bigDialogState,
            showUseage,
            submit,
            showMenu,
            capture,
            selected,
            useage_selected,
            toggle,
            closeBigDialog,
            showBigDialog
        }
    }
}
</script>